export enum UserStatus {
	Active = 10,
	Unverified = 20,
	Blacklisted = 30,
	Deleted = 40
}